var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMidBrandResponsiveRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 453,
    height: 49,
    viewBox: "0 0 453 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.8 37.8C65.8 33.8 62.6 30.6 58.6 30.6H58.5C58.6 30 58.8 29.3 58.8 28.7C58.8 24.7 55.6 21.5 51.6 21.5C49.7 21.5 48 22.2 46.7 23.4C44.2 20.1 40.3 18 35.9 18C31.6 18 27.7 20.1 25.2 23.2C22.7 20 18.9 18 14.5 18C7 18 1 24 1 31.5C1 39 7 45 14.5 45H35.8H38H59.3L59.2 44.9C63 44.5 65.8 41.5 65.8 37.8Z",
    fill: "#F1E8E6",
    stroke: "white",
    strokeWidth: 0.6506,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M452.023 21.7208C452.023 17.558 448.623 14.1584 444.46 14.1584C444.391 14.1584 444.391 14.1584 444.391 14.1584C444.599 13.534 444.668 12.8402 444.668 12.1465C444.668 7.9837 441.269 4.58412 437.106 4.58412C435.164 4.58412 433.36 5.34729 432.041 6.52674C429.474 3.05778 425.312 0.837646 420.663 0.837646C416.084 0.837646 411.991 3.05778 409.424 6.38798C406.857 3.05778 402.763 0.837646 398.184 0.837646C390.345 0.837646 383.962 7.22053 383.962 15.0604C383.962 22.9002 390.345 29.2831 398.184 29.2831H420.663H423.022H445.501L445.432 29.2137C449.109 28.7974 452.023 25.606 452.023 21.7208Z",
    fill: "#F1E8E6",
    stroke: "white",
    strokeWidth: 0.534149,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M370.435 43.4609C370.435 40.5683 368.053 38.1861 365.16 38.1861H365.075C365.16 37.7608 365.33 37.2503 365.33 36.8249C365.33 33.9323 362.948 31.5502 360.055 31.5502C358.694 31.5502 357.503 32.0607 356.482 32.9114C354.696 30.5293 351.888 28.9128 348.655 28.9128C343.295 28.9128 338.871 33.3368 338.871 38.6966C338.871 44.0564 343.295 48.4804 348.655 48.4804H365.841C368.393 48.3102 370.435 46.0982 370.435 43.4609Z",
    fill: "#754C4E",
    stroke: "white",
    strokeWidth: 0.674,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMidBrandResponsiveRight);
export default __webpack_public_path__ + "static/media/mid_brand_responsive_right.90b6d89f36b8287913112639efe759e9.svg";
export { ForwardRef as ReactComponent };